// Third-party Imports
import styled from '@emotion/styled'

// Util Imports
import { verticalNavClasses } from '../../utils/menuClasses'

// Hook Imports
import useVerticalNav from '../../hooks/useVerticalNav'

const StyledNavHeader = styled.div`
  padding: 15px;
  padding-inline: ${({ isCollapsed }) => (isCollapsed ? '0px' : '20px')};
  display: flex;
  align-items: center;
  justify-content: ${({ isCollapsed }) => (isCollapsed ? 'center' : 'space-between')};
`

const NavHeader = ({ children }) => {
  const { isCollapsed } = useVerticalNav()

  return (
    <StyledNavHeader isCollapsed={isCollapsed} className={verticalNavClasses.header}>
      {children}
    </StyledNavHeader>
  )
}

export default NavHeader
